import createSagaMiddleware from "redux-saga";
import {
  spawn,
  call,
  all
} from "redux-saga/effects";

const sagaMiddleware = createSagaMiddleware();

let mappedSagas = [];

function* getRootSaga() {
  for (let saga of mappedSagas) {
    yield spawn(function* () {
      while (true) {
        try {
          yield call(saga);
          break;
        } catch (e) {
          console.error(e);
        }
      }
    });
  }
}

let CommonSagas = [];
const setCommonSagas = commonSagas => {
  CommonSagas = commonSagas
};

const setSagas = requireComponent => {
  mappedSagas = [...CommonSagas, ...requireComponent.keys().map(fileName => requireComponent(fileName).default)];
  runSagas();
};

const runSagas = requireComponent => {
  sagaMiddleware.run(getRootSaga);
};
export {
  runSagas,
  setSagas,
  setCommonSagas
};
export default sagaMiddleware;
